module.exports = __webpack_public_path__ + "img/avalon-2020.jpg.f85365cb.webp";